var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgByDaysTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 1.11816H3C1.89543 1.11816 1 2.0136 1 3.11816V17.8821C1 19.3689 2.56462 20.3359 3.89443 19.6709L4.10557 19.5654C4.66863 19.2838 5.33137 19.2838 5.89443 19.5654L8.10557 20.6709C8.66863 20.9525 9.33137 20.9525 9.89443 20.6709L12.1056 19.5654C12.6686 19.2838 13.3314 19.2838 13.8944 19.5654L14.1056 19.671C15.4354 20.3359 17 19.3689 17 17.8821V3.11816C17 2.01359 16.1046 1.11816 15 1.11816Z",
    fill: "#E5E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5.11816H13M5 9.11816H13M5 13.1182H13M3 1.11816H15C16.1046 1.11816 17 2.01359 17 3.11816V17.8821C17 19.3689 15.4354 20.3359 14.1056 19.671L13.8944 19.5654C13.3314 19.2838 12.6686 19.2838 12.1056 19.5654L9.89443 20.6709C9.33137 20.9525 8.66863 20.9525 8.10557 20.6709L5.89443 19.5654C5.33137 19.2838 4.66863 19.2838 4.10557 19.5654L3.89443 19.6709C2.56462 20.3359 1 19.3689 1 17.8821V3.11816C1 2.0136 1.89543 1.11816 3 1.11816Z",
    stroke: "#8278F0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByDaysTab);
export default __webpack_public_path__ + "static/media/by_days_tab.10c0ba4cd8193a6df96101cd55df9ad6.svg";
export { ForwardRef as ReactComponent };